// extracted by mini-css-extract-plugin
export default {"embed":"embed_embed__635bk","verticalEmbed":"embed_verticalEmbed__WT4fz"};